
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-in/greetings",
      function () {
        return require("private-next-pages/auth/sign-in/greetings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/sign-in/greetings"])
      });
    }
  